import React from 'react';
import PropTypes from 'prop-types';
import { CsrfContext, GroupsContext, UserContext } from '../Context';

function WindowContextProvider({
  activeUser, groups, children, csrfToken,
}) {
  return (
    <UserContext.Provider value={activeUser}>
      <GroupsContext.Provider value={groups}>
        <CsrfContext.Provider value={csrfToken}>
          {children}
        </CsrfContext.Provider>
      </GroupsContext.Provider>
    </UserContext.Provider>
  );
}

WindowContextProvider.propTypes = {
  activeUser: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    picture: PropTypes.string,
  }).isRequired,
  groups: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  csrfToken: PropTypes.string.isRequired,
  children: PropTypes.node,
};

WindowContextProvider.defaultProps = {
  groups: {},
  children: null,
};

export default WindowContextProvider;
